(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lab-compendium-restriction', {
                parent: 'entity',
                url: '/lab-compendium-restriction',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'LabCompendiumRestrictions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-compendium-restriction/list/lab-compendium-restriction.html',
                        controller: 'LabCompendiumRestrictionController',
                        controllerAs: 'vm'
                    }
                },
            })
    }
})();
